/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { theme, pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- NAV : STYLES --------------- ++++++++++ */
export default {
	migrationcomplete: {
    display: 'flex',
    flexDirection: 'column',
    gap: pxToEm(16),
    '& .button': {
      color: theme.color.primary.medium.contrast,
      background: theme.color.primary.medium.swatch
    }
  }
}; 